<template>
    <v-menu offset-y :close-on-content-click="false">
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" small class="mr-n2">
                <v-icon left>mdi-tune-variant</v-icon>
                <span>Filters</span>
            </v-btn>
        </template>
        <v-list nav dense>
            <v-sheet rounded class="py-2 px-4 my-1">
                <v-switch inset dense hide-details class="pa-0 ma-0" :input-value="isSelected('accounts')" @change="setTypeSelection('accounts', $event)">
                    <template v-slot:label>
                        <div class="d-flex align-center">
                            <v-icon left small color="primary">mdi-account-box-outline</v-icon>
                            <span>Accounts</span>
                        </div>
                    </template>
                </v-switch>
            </v-sheet>

            <v-sheet rounded class="py-2 px-4 my-1">
                <v-switch inset dense hide-details class="pa-0 ma-0" :input-value="isSelected('wallets')" @change="setTypeSelection('wallets', $event)">
                    <template v-slot:label>
                        <div class="d-flex align-center">
                            <v-icon left small color="primary">mdi-wallet-outline</v-icon>
                            <span>Wallets</span>
                        </div>
                    </template>
                </v-switch>
            </v-sheet>
        </v-list>
    </v-menu>
</template>

<script>
const POOL_TYPE_ORDER = ['accounts', 'wallets']

export default {
    name: 'PoolTypeFilterMenu',
    props: {
        value: {
            type: Array,
            default: null
        }
    },
    computed: {
        selectedPoolTypes() {
            if (!Array.isArray(this.value)) {
                return POOL_TYPE_ORDER.slice()
            }

            const validPoolTypes = this.value.filter(type => POOL_TYPE_ORDER.includes(type))
            return Array.from(new Set(validPoolTypes))
        }
    },
    methods: {
        isSelected(poolType) {
            return this.selectedPoolTypes.includes(poolType)
        },
        setTypeSelection(poolType, selected) {
            const nextSelectedPoolTypes = [...this.selectedPoolTypes]

            if (selected) {
                if (!nextSelectedPoolTypes.includes(poolType)) {
                    nextSelectedPoolTypes.push(poolType)
                }
            } else {
                const typeIndex = nextSelectedPoolTypes.indexOf(poolType)
                if (typeIndex !== -1) {
                    nextSelectedPoolTypes.splice(typeIndex, 1)
                }
            }

            this.$emit('input', nextSelectedPoolTypes)
        }
    }
}
</script>
